import { TILE } from '../core/constants';
export function makeBomb(opts) {
    return {
        col: opts.col, row: opts.row,
        x: opts.col * TILE + TILE / 2,
        y: opts.row * TILE + TILE / 2,
        range: opts.range,
        fuse: opts.fuse,
        ownerId: opts.ownerId,
        exploded: false,
        remote: opts.remote,
        motion: null,
    };
}
export var FlameKind;
(function (FlameKind) {
    FlameKind[FlameKind["Center"] = 0] = "Center";
    FlameKind[FlameKind["Horizontal"] = 1] = "Horizontal";
    FlameKind[FlameKind["Vertical"] = 2] = "Vertical";
    FlameKind[FlameKind["EndLeft"] = 3] = "EndLeft";
    FlameKind[FlameKind["EndRight"] = 4] = "EndRight";
    FlameKind[FlameKind["EndUp"] = 5] = "EndUp";
    FlameKind[FlameKind["EndDown"] = 6] = "EndDown";
})(FlameKind || (FlameKind = {}));
export function key(c, r) {
    return `${c},${r}`;
}
